import { useState, useCallback } from 'react';

interface UseFilePickerOptions {
  accept?: string;
}

interface UseFilePickerResult {
  openFile: () => Promise<File | null>;
  file: File | null;
}

const useFilePicker = (options: UseFilePickerOptions = {}): UseFilePickerResult => {
  const [file, setFile] = useState<File | null>(null);

  const openFile = useCallback((): Promise<File | null> => {
    return new Promise((resolve, reject) => {
      const input = document.createElement('input');
      input.type = 'file';

      if (options.accept) {
        input.accept = options.accept;
      }

      input.onchange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        const selectedFile = target.files?.[0] || null;
        if (selectedFile) {
          setFile(selectedFile);
          resolve(selectedFile);
        } else {
          reject(new Error('No file selected'));
        }
      };

      input.onerror = (error) => {
        reject(error);
      };

      input.click();
    });
  }, [options]);

  return { openFile, file };
};

export default useFilePicker;
